(() => {
  "use strict";

  const CONFIG = {
    stadiaApiKey: "",
    initialCenter: [10, 30],
    initialZoom: 2,
    locale: "en",
  };

  const svg_icon =
    "<svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.55676 14.3712C0.329425 12.4398 -0.205499 10.0751 0.0714667 7.80179C0.114912 7.44765 0.180081 7.08669 0.357936 6.77749C0.808684 5.99701 1.89346 6.01199 2.6782 5.98747C3.71818 5.95478 4.75816 6.0406 5.79813 6.02561C7.70295 5.99973 9.59419 5.64286 11.4189 5.08985C12.8784 4.64853 14.3406 4.05465 15.4335 2.98812C15.5231 2.90095 15.6209 2.80424 15.7458 2.79062C15.9209 2.77155 16.0744 2.93091 16.111 3.1039C16.1463 3.27689 16.0947 3.45396 16.035 3.62014C15.8191 4.23036 15.5123 4.80381 15.1634 5.35001C13.788 7.50213 11.7977 9.18705 9.71502 10.6608C9.61184 10.733 9.50594 10.808 9.38239 10.8325C9.2249 10.8638 9.0647 10.812 8.91128 10.7657C7.45993 10.3312 5.84837 10.4116 4.47712 11.0559C3.10858 11.7015 2.00072 12.9192 1.55676 14.3712Z' fill='black'/><path d='M3.03125 16.0317C3.73317 16.1883 4.4378 15.8287 5.05283 15.4542C6.02764 14.8603 6.959 14.201 7.86864 13.5132C8.64387 12.9261 9.80333 11.9141 9.80333 11.9141C9.80333 11.9141 14.338 12.8921 16.1953 13.6208C16.236 13.6371 16.9094 13.915 16.9053 13.9191C15.5354 16.221 13.1065 17.8583 10.4645 18.2615C7.82248 18.6646 5.02024 17.8215 3.03125 16.0317Z' fill='black'/><path d='M10.7894 11.1656C10.7867 11.1643 10.784 11.1629 10.7812 11.1629C11.4031 10.7366 11.8769 10.2435 12.4349 9.79125C13.0092 9.32541 13.574 8.84595 14.1266 8.35287C14.6791 7.86115 15.2208 7.35581 15.7503 6.83821C16.0205 6.57396 16.288 6.30699 16.5514 6.0373C16.6274 5.95966 17.3307 5.31129 17.3022 5.25C18.3462 7.47431 18.4752 10.1127 17.6538 12.4283C17.4949 12.8764 17.0836 12.7565 16.4346 12.5836C15.4842 12.3302 14.5936 12.1504 13.6256 11.9148C12.6752 11.6832 11.733 11.4762 10.7894 11.1656Z' fill='black'/><path d='M6.00881 4.99811C5.76579 5.01173 5.59065 5.00628 5.58657 4.95997C5.56349 4.69981 6.1758 4.27892 6.36452 4.14952C6.81934 3.8376 7.24429 3.48345 7.63259 3.09117C8.40918 2.3066 9.03778 1.37492 9.46409 0.356064C9.50482 0.257992 9.54691 0.155834 9.62972 0.0890914C9.73698 0.0019168 9.88768 -0.00216951 10.0248 0.000554696C11.5658 0.0346073 13.0945 0.512706 14.3829 1.3613C14.5282 1.45664 14.6816 1.57651 14.7074 1.74813C14.7251 1.86391 14.6789 1.98105 14.626 2.08593C14.3178 2.70978 13.7856 3.20013 13.1909 3.55701C12.1564 4.17812 10.9426 4.41649 9.75056 4.59493C9.00384 4.70662 8.25169 4.76519 7.50089 4.8333C7.35969 4.84556 6.52744 4.96814 6.00881 4.99811Z' fill='black'/><path d='M0.89265 5.61772C0.887219 5.61908 0.880431 5.62044 0.875 5.62317C0.971395 4.97889 1.25651 4.37139 1.63665 3.8429C2.85177 2.15662 4.84891 1.13504 6.74151 0.414485C6.87592 0.362726 7.04698 0.319138 7.15017 0.421296C7.23298 0.503022 7.22484 0.636508 7.20583 0.750925C7.12573 1.23447 6.94923 1.70167 6.68856 2.11575C6.2894 2.75049 5.70696 3.24902 5.09193 3.67672C3.82115 4.56209 2.38202 5.1941 0.89265 5.61772Z' fill='black'/><path d='M8.55931 11.5656C8.50364 11.6188 8.47377 11.6514 8.43983 11.6787C7.60215 12.357 6.75632 13.0258 5.88197 13.6565C5.41222 13.9956 4.92753 14.313 4.40618 14.5691C4.0559 14.7421 3.68797 14.8429 3.29968 14.8551C3.09603 14.8619 2.89373 14.8292 2.7023 14.7543C2.66021 14.738 2.61948 14.7175 2.58147 14.6944C2.31944 14.5296 2.19725 14.313 2.32351 13.9766C2.43756 13.6755 2.62492 13.4208 2.8435 13.1879C3.28339 12.718 3.81695 12.3802 4.38718 12.0969C4.80127 11.8912 5.22757 11.7141 5.67289 11.5888C5.94171 11.5125 6.22003 11.4676 6.49564 11.4213C6.79026 11.3722 7.08895 11.3681 7.38899 11.3818C7.66053 11.394 7.92935 11.4321 8.19409 11.4921C8.30135 11.5139 8.41132 11.5357 8.55931 11.5656Z' fill='black'/></svg>";

  // ---------------- state ----------------

  const state = {
    locations: [],
    search: "",
    selectedUid: null,
    hoveredUid: null,
    bounds: null,
    userInteracted: false,
    mapLoaded: false,
    view: "map", // mobile: 'map' | 'list'
    suggestionsOpen: false,
    suggestionIndex: -1,
    previousCamera: null,
  };

  const desktopQuery = window.matchMedia("(min-width: 1025px)");

  const els = {
    layout: document.querySelector(".locations-layout"),
    searchInput: document.getElementById("search-input"),
    suggestions: document.getElementById("suggestions"),
    locationsSidebar: document.getElementById("locations-sidebar"),
    list: document.getElementById("location-list"),
    listScroll: document.getElementById("list-scroll"),
    noResults: document.getElementById("no-results"),
    resetZoom: document.getElementById("reset-zoom"),
    mapRegion: document.getElementById("map-region"),
    mapLoading: document.getElementById("map-loading"),
    zoomIn: document.getElementById("zoom-in"),
    zoomOut: document.getElementById("zoom-out"),
    viewToggle: document.getElementById("view-toggle"),
    viewToggleLabel: document.getElementById("view-toggle-label"),
    viewToggleIcon: document.getElementById("view-toggle-icon"),
    overlay: document.getElementById("detail-overlay"),
    panel: document.getElementById("detail-panel"),
    detailClose: document.getElementById("detail-close"),
    detailCategory: document.getElementById("detail-category"),
    detailTitle: document.getElementById("detail-title"),
    detailAddress: document.getElementById("detail-address"),
    detailContact: document.getElementById("detail-contact"),
    detailDirections: document.getElementById("detail-directions"),
    //detailWebsite: document.getElementById("detail-website"),
    detailEmail: document.getElementById("detail-email"),
    detailNearest: document.getElementById("detail-nearest"),
  };

  let map = null;
  const markers = new Map(); // uid -> maplibregl.Marker

  // ---------------- helpers ----------------

  // same normalization as the original: strip diacritics, lowercase,
  // drop everything that is not a letter or a number
  const normalize = (str) =>
    str
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, "");

  const getLon = (ml) => (ml ? (ml.lng ?? ml.lon) : undefined);
  const hasCoords = (loc) =>
    !!(loc.maplocation && loc.maplocation.lat && getLon(loc.maplocation));

  const coordsOf = (uid) => {
    const loc = state.locations.find((l) => l.uid === uid);
    if (!loc || !hasCoords(loc)) return null;
    return [getLon(loc.maplocation), loc.maplocation.lat];
  };

  const byTitle = (a, b) =>
    (a.title || "").localeCompare(b.title || "", CONFIG.locale, {
      sensitivity: "base",
    });

  // locations matching type filter + search text
  const filteredLocations = () => {
    const term = state.search.trim();
    const needle = term ? normalize(term) : "";
    return state.locations.filter((loc) => {
      //const typeOk = state.types.includes(loc.type);
      //if (!needle) return typeOk;
      const haystacks = [loc.title, loc.address2, loc.city, loc.country]
        .filter(Boolean)
        .map(normalize);
      return /*typeOk &&*/ haystacks.some((h) => h.includes(needle));
    });
  };

  // list entries: on desktop, after user interaction and with no search
  // term, restrict to the current map bounds
  const displayedLocations = () => {
    const filtered = filteredLocations();
    const b = state.bounds;
    if (!b) return [...filtered].sort(byTitle);
    const inBounds = (loc) => {
      const lat = loc.maplocation?.lat;
      const lon = getLon(loc.maplocation);
      if (lat == null || lon == null) return false;
      return lat >= b.south && lat <= b.north && lon >= b.west && lon <= b.east;
    };
    const useBounds =
      desktopQuery.matches && state.userInteracted && !state.search.trim();
    return [...(useBounds ? filtered.filter(inBounds) : filtered)].sort(
      byTitle,
    );
  };

  // ---------------- URL sync ----------------

  const readQuery = () => {
    const q = new URLSearchParams(window.location.search);
    state.search = q.get("search") || "";
    //state.types = parseTypes(q.get("type"));
    state.selectedUid = q.get("location") || null;
  };

  const writeQuery = (mode) => {
    const q = new URLSearchParams();
    //if (!sameTypes(state.types, ["boutique"]))
    //q.set("type", state.types.join(","));
    if (state.search) q.set("search", state.search);
    if (state.selectedUid) q.set("location", state.selectedUid);
    const qs = q.toString();
    const url = qs
      ? `${window.location.pathname}?${qs}`
      : window.location.pathname;
    if (mode === "push") history.pushState(null, "", url);
    else history.replaceState(null, "", url);
  };

  // ---------------- marker DOM ----------------

  const buildIcon = () => {
    const parser = new DOMParser();
    const svgDocument = parser.parseFromString(svg_icon, "image/svg+xml");
    const svgElement = svgDocument.documentElement;
    return svgElement;
  };

  const buildMarkerElement = (/*type*/) => {
    const root = document.createElement("div");
    root.className = "marker-root";
    root.style.setProperty("--bg", "#000000");
    root.style.setProperty("--fg", "#FFFFFF");
    const wrapper = document.createElement("div");
    wrapper.className = "marker-wrapper";
    const pill = document.createElement("div");
    pill.className = "marker-pill";
    pill.appendChild(buildIcon());

    const pointer = document.createElement("div");
    pointer.className = "marker-pointer";
    wrapper.appendChild(pill);
    root.appendChild(wrapper);
    return root;
  };

  const syncMarkerState = (uid) => {
    const el = markers.get(uid)?.getElement();
    if (!el) return;
    const hovered = state.hoveredUid === uid;
    const active = state.selectedUid === uid;
    el.classList.toggle("is-hovered", hovered);
    el.classList.toggle("is-active", active);
    el.style.zIndex = hovered || active ? "1000" : "";
  };

  const rebuildMarkers = () => {
    if (!map || !state.mapLoaded) return;
    for (const marker of markers.values()) marker.remove();
    markers.clear();
    for (const loc of filteredLocations()) {
      if (!hasCoords(loc)) continue;
      const el = buildMarkerElement(/*loc.type*/);
      el.addEventListener("click", (e) => {
        e.stopPropagation();
        selectLocation(loc.uid);
      });
      const marker = new maplibregl.Marker({ element: el, anchor: "bottom" })
        .setLngLat([getLon(loc.maplocation), loc.maplocation.lat])
        .addTo(map);
      markers.set(loc.uid, marker);
      syncMarkerState(loc.uid);
    }
  };

  // ---------------- map ----------------

  const initMap = async () => {
    const style = await fetch(els.layout.dataset.mapStyle).then((r) =>
      r.json(),
    );

    const transformRequest = CONFIG.stadiaApiKey
      ? (url) => {
          if (!url.includes("stadiamaps.com")) return { url };
          const u = new URL(url);
          u.searchParams.set("api_key", CONFIG.stadiaApiKey);
          return { url: u.toString() };
        }
      : undefined;

    map = new maplibregl.Map({
      container: "map",
      style,
      center: CONFIG.initialCenter,
      zoom: CONFIG.initialZoom,
      minZoom: CONFIG.initialZoom,
      renderWorldCopies: false,
      attributionControl: false,
      dragRotate: false,
      transformRequest,
    });
    map.touchZoomRotate.disableRotation();

    map.on("load", () => {
      state.mapLoaded = true;
      els.mapLoading.remove();
      rebuildMarkers();
      if (state.selectedUid) {
        const c = coordsOf(state.selectedUid);
        if (c) map.jumpTo({ center: c, zoom: 15 });
        openDetail(state.selectedUid);
      }
      emitBounds();
      map.on("moveend", emitBounds);
    });

    map.on("dragstart", (e) => {
      if (e.originalEvent) onUserInteract();
    });
    map.on("zoomstart", (e) => {
      if (e.originalEvent) onUserInteract();
    });

    new ResizeObserver(() => map.resize()).observe(
      document.getElementById("map"),
    );
  };

  const emitBounds = () => {
    const b = map.getBounds();
    state.bounds = {
      north: b.getNorth(),
      south: b.getSouth(),
      east: b.getEast(),
      west: b.getWest(),
    };
    renderList();
  };

  const onUserInteract = () => {
    state.userInteracted = true;
  };

  const resetView = () => {
    map?.flyTo({
      center: CONFIG.initialCenter,
      zoom: CONFIG.initialZoom,
      duration: 1200,
    });
  };

  // ---------------- location selection / detail panel ----------------

  const selectLocation = (uid) => {
    if (state.selectedUid === uid) return;

    if (state.mapLoaded) {
      const center = map.getCenter();

      state.previousCamera = {
        center: [center.lng, center.lat],
        zoom: map.getZoom(),
        bearing: map.getBearing(),
        pitch: map.getPitch(),
      };
    }

    state.selectedUid = uid;
    writeQuery("push");
    syncAllMarkers();

    if (state.mapLoaded) {
      const c = coordsOf(uid);

      if (c) {
        map.flyTo({
          center: c,
          zoom: 15,
          duration: 2000,
        });
      }

      /*
      if (desktopQuery.matches) {
        if (c) {
          map.flyTo({
            center: c,
            zoom: 15,
            duration: 2000,
          });
        }
      } else {
        if (c) {
          map.flyTo({
            center: c,
            zoom: map.getZoom(),
            duration: 2000,
          });
      }
        }*/
    }

    openDetail(uid);
  };

  const deselectLocation = () => {
    if (!state.selectedUid) return;

    state.selectedUid = null;
    writeQuery("replace");
    syncAllMarkers();

    if (state.mapLoaded /*&& desktopQuery.matches*/ && state.previousCamera) {
      map.flyTo({
        ...state.previousCamera,
        duration: 1200,
      });
    }

    state.previousCamera = null;
    closeDetail();
  };

  const syncAllMarkers = () => {
    for (const uid of markers.keys()) syncMarkerState(uid);
  };

  const openDetail = (uid) => {
    const loc = state.locations.find((l) => l.uid === uid);
    if (!loc) return;

    els.detailTitle.textContent = loc.title;
    els.detailAddress.innerHTML = loc.address2 || "";
    els.detailContact.innerHTML = loc.contact || "";

    if (loc.website) {
      const website_url = loc.website.replace(/<[^>]*>/g, "");
      els.detailDirections.href = website_url;
      els.detailDirections.hidden = false;
    } else {
      els.detailDirections.hidden = true;
    }

    const hasWebsite = !!loc.website;
    const hasEmail = !!loc.email;
    //els.detailLinks.hidden = !(hasWebsite || hasEmail);
    //els.detailWebsite.hidden = !hasWebsite;
    els.detailEmail.hidden = !hasEmail;
    /*
    if (hasWebsite) {
      els.detailWebsite.innerHTML = loc.website;
      els.detailWebsite.href = loc.website;
      els.detailWebsite.classList.add("underline");
      els.detailWebsite.classList.add("retailer-link");
    }
    */
    if (hasEmail) {
      els.detailEmail.innerHTML = loc.email;
      els.detailEmail.classList.add("underline");
      els.detailEmail.classList.add("retailer-link");
    }

    //els.overlay.hidden = false;
    els.panel.hidden = false;
    requestAnimationFrame(() => {
      //els.overlay.classList.add("is-visible");
      els.panel.classList.add("is-visible");
    });
    document.body.classList.add("detail-open");
  };

  const closeDetail = () => {
    //els.overlay.classList.remove("is-visible");
    els.panel.classList.remove("is-visible");
    document.body.classList.remove("detail-open");
    setTimeout(() => {
      if (!state.selectedUid) {
        //els.overlay.hidden = true;
        els.panel.hidden = true;
      }
    }, 300);
  };

  // ---------------- list rendering ----------------

  const renderList = () => {
    const items = displayedLocations();
    els.list.innerHTML = "";
    els.noResults.hidden = items.length > 0;
    if (!items.length) {
      // offer reset only when locations exist outside the current bounds
      els.resetZoom.hidden = filteredLocations().length === 0;
      return;
    }
    const frag = document.createDocumentFragment();
    for (const loc of items) {
      const item = document.createElement("div");
      item.className = "location-item";
      item.dataset.uid = loc.uid;

      const title = document.createElement("h4");
      title.className = "";
      title.textContent = loc.title;

      const address = document.createElement("div");
      address.className = "";
      address.innerHTML = loc.address2 || "";

      const icon = document.createElement("div");
      icon.className = "location-item-icon";
      icon.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="9.5" x2="20" y2="9.5" stroke="black"/><line x1="10.5" y1="2.18557e-08" x2="10.5" y2="20" stroke="black"/></svg>';

      item.append(title, address, icon);
      item.addEventListener("click", () => selectLocation(loc.uid));
      item.addEventListener("mouseenter", () => {
        state.hoveredUid = loc.uid;
        syncMarkerState(loc.uid);
      });
      item.addEventListener("mouseleave", () => {
        const prev = state.hoveredUid;
        state.hoveredUid = null;
        if (prev) syncMarkerState(prev);
      });
      frag.appendChild(item);
    }
    els.list.appendChild(frag);
  };

  // ---------------- filters ----------------

  const syncCheckboxes = () => {};

  const onFiltersChanged = () => {
    writeQuery("replace");
    //syncCheckboxes();
    rebuildMarkers();
    renderList();
  };

  // ---------------- search suggestions ----------------

  const suggestionValues = () => {
    // unique city/country values from type-filtered locations
    const byKey = new Map();
    for (const loc of state.locations) {
      //if (!state.types.includes(loc.type)) continue;
      for (const value of [loc.city, loc.country]) {
        const v = value?.trim();
        if (!v) continue;
        const key = v.toLowerCase();
        if (!byKey.has(key)) byKey.set(key, v);
      }
    }
    return [...byKey.values()].sort((a, b) => a.localeCompare(b));
  };

  const currentSuggestions = () => {
    const term = state.search.trim();
    if (!term) return [];
    const needle = normalize(term);
    return suggestionValues()
      .filter((v) => normalize(v).startsWith(needle))
      .slice(0, 6);
  };

  const renderSuggestions = () => {
    const items = currentSuggestions();
    const visible =
      state.suggestionsOpen &&
      items.length > 0 &&
      state.search.trim().length > 0;
    els.suggestions.hidden = !visible;
    if (!visible) return;
    els.suggestions.innerHTML = "";
    items.forEach((value, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className =
        "suggestion-item" + (i === state.suggestionIndex ? " is-active" : "");
      btn.textContent = value;
      btn.addEventListener("mousedown", (e) => {
        e.preventDefault();
        applySuggestion(value);
      });
      els.suggestions.appendChild(btn);
    });
  };

  const applySuggestion = (value) => {
    state.search = value;
    els.searchInput.value = value;
    state.suggestionIndex = -1;
    state.suggestionsOpen = false;
    els.searchInput.blur();
    renderSuggestions();
    // onFiltersChanged(false);
    onFiltersChanged();
  };

  // ---------------- events ----------------

  const switchToMapView = () => {
    if (desktopQuery.matches || state.view === "map") return;

    state.view = "map";
    els.layout.dataset.view = "map";

    els.viewToggleLabel.textContent = "Change to List";
    els.viewToggleIcon.hidden = false;
    document.getElementById("view-toggle-pin").hidden = true;

    els.locationsSidebar.style.height = "auto";

    window.scrollTo(0, 0);

    requestAnimationFrame(() => {
      map?.resize();
    });
  };

  const bindEvents = () => {
    // search input
    els.searchInput.addEventListener("input", () => {
      state.search = els.searchInput.value;
      state.suggestionIndex = -1;
      renderSuggestions();
      // onFiltersChanged(false);
      onFiltersChanged();
    });
    els.searchInput.addEventListener("focus", () => {
      state.suggestionsOpen = true;
      renderSuggestions();
    });
    els.searchInput.addEventListener("blur", () => {
      setTimeout(() => {
        state.suggestionsOpen = false;
        state.suggestionIndex = -1;
        renderSuggestions();
      }, 120);
    });
    els.searchInput.addEventListener("keydown", (e) => {
      const items = currentSuggestions();
      if (e.key === "ArrowDown") {
        if (!items.length) return;
        e.preventDefault();
        state.suggestionsOpen = true;
        state.suggestionIndex = Math.min(
          state.suggestionIndex + 1,
          items.length - 1,
        );
        renderSuggestions();
      } else if (e.key === "ArrowUp") {
        if (els.suggestions.hidden) return;
        e.preventDefault();
        state.suggestionIndex = Math.max(state.suggestionIndex - 1, -1);
        renderSuggestions();
      } else if (e.key === "Enter") {
        if (!els.suggestions.hidden && state.suggestionIndex >= 0) {
          e.preventDefault();
          applySuggestion(items[state.suggestionIndex]);
        }
      } else if (e.key === "Escape") {
        state.suggestionsOpen = false;
        state.suggestionIndex = -1;
        els.searchInput.blur();
        renderSuggestions();
      }
    });

    // zoom controls
    els.zoomIn.addEventListener("click", () => {
      onUserInteract();
      map?.zoomIn();
    });
    els.zoomOut.addEventListener("click", () => {
      onUserInteract();
      map?.zoomOut();
    });

    // no-results reset
    els.resetZoom.addEventListener("click", () => {
      state.userInteracted = false;
      resetView();
    });

    // mobile list/map toggle
    els.viewToggle.addEventListener("click", () => {
      state.view = state.view === "map" ? "list" : "map";
      els.layout.dataset.view = state.view;
      els.viewToggleLabel.textContent =
        state.view === "map" ? "Change to List" : "Change to Map";
      els.viewToggleIcon.hidden = state.view !== "map";
      document.getElementById("view-toggle-pin").hidden = state.view === "map";
      if (state.view === "list") {
        window.scrollTo(0, 0);
        deselectLocation();
        els.listScroll.scrollTo({ top: 0 });
        els.locationsSidebar.style.height = "inherit";
      }
      if (state.view === "map") {
        window.scrollTo(0, 0);
        deselectLocation();
        map?.resize();
        els.locationsSidebar.style.height = "auto";
      }
    });

    // detail close
    els.detailClose.addEventListener("click", deselectLocation);
    //els.overlay.addEventListener("click", deselectLocation);
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && state.selectedUid) deselectLocation();
    });

    els.detailNearest.addEventListener("click", () => {
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          state.search = "";
          els.searchInput.value = "";
          state.suggestionsOpen = false;
          state.suggestionIndex = -1;
          renderSuggestions();
          onFiltersChanged();

          switchToMapView();

          requestAnimationFrame(() => {
            map?.resize();

            map?.flyTo({
              center: [coords.longitude, coords.latitude],
              zoom: 4,
              essential: true,
            });
          });
        },
        (error) => {},
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    });

    // history navigation
    window.addEventListener("popstate", () => {
      const prevSelected = state.selectedUid;
      readQuery();
      els.searchInput.value = state.search;
      // syncCheckboxes();
      rebuildMarkers();
      renderList();
      renderSuggestions();
      if (state.selectedUid && state.selectedUid !== prevSelected) {
        const c = coordsOf(state.selectedUid);
        if (state.mapLoaded && c)
          map.flyTo({ center: c, zoom: 15, duration: 2000 });
        openDetail(state.selectedUid);
      } else if (!state.selectedUid && prevSelected) {
        syncAllMarkers();
        closeDetail();
      }
    });

    // desktop/mobile breakpoint change re-evaluates the bounds filter
    desktopQuery.addEventListener("change", renderList);
  };

  // ---------------- boot ----------------

  const boot = async () => {
    readQuery();
    els.searchInput.value = state.search;
    els.layout.dataset.view = state.view;
    // syncCheckboxes();

    const data = await fetch(els.layout.dataset.mapLocations).then((r) =>
      r.json(),
    );
    state.locations = data.locations || [];
    renderList();
    bindEvents();
    await initMap();
  };

  boot();
})();
